'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _iBem = require('../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'progress',
    willReceiveProps: function willReceiveProps(_ref) {
        var value = _ref.value;

        this._update(value);
    },
    mods: function mods(_ref2) {
        var timing = _ref2.timing;

        return { timing: timing };
    },
    _update: function _update(value) {
        var progress = _reactDom2.default.findDOMNode(this);
        progress.style.width = value <= 0 ? '0' : value >= 1 ? '100%' : (value * 100).toPrecision(2) + '%';
    }
});